<div *ngIf="rows.length; else noRows" class="table-responsive">
  <table class="table table-bordered table-sm mb-0">
    <thead>
      <tr>
        <th *ngFor="let title of columnTitles" class="bg-light">{{ title }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows">
        <td *ngFor="let cell of row" class="text-pre-line align-top">{{ cell }}</td>
      </tr>
    </tbody>
  </table>
</div>
<ng-template #noRows>
  <div>-</div>
</ng-template>
